import "./style.scss";

import TextSkeleton from "components/shared/TextSkeleton";
import TitleCover from "components/shared/TitleCover";

import type { IWorkTitleSummary } from "../types";
import WorkTitleTags from "../WorkTitleTags";

type WorkTitleCardProps = {
    title?: IWorkTitleSummary;
    index: number;
    openLabel: string;
    ean13Label: string;
    formatLabel: string;
    onOpen: (titleId: number) => void;
    isLoading?: boolean;
};

const WorkTitleCard = ({
    title,
    index,
    openLabel,
    ean13Label,
    formatLabel,
    onOpen,
    isLoading = false,
}: WorkTitleCardProps) => {
    const formatName = title?.formatTypeName?.trim();
    return (
        <button
            type="button"
            className={`work-title-card${isLoading ? " work-title-card--loading" : ""}`}
            style={{ animationDelay: `${index * 40}ms` }}
            disabled={isLoading || !title}
            onClick={() => title && onOpen(title.id)}
        >
            <div className="work-title-card__body">
                {isLoading || !title ? (
                    <TextSkeleton variant="rounded" width={52} height={68} />
                ) : (
                    <TitleCover
                        title={title.name}
                        coverUrl={title.avatarUrl ?? undefined}
                        style={{ width: 52, minWidth: 52 }}
                    />
                )}
                <div className="work-title-card__copy">
                    {!isLoading && <WorkTitleTags tags={title?.tags} className="work-title-card__tags" />}
                    <h4 className="work-title-card__name">
                        {isLoading || !title ? <TextSkeleton width="70%" /> : title.name}
                    </h4>
                    {!isLoading && formatName ? (
                        <p className="work-title-card__format">
                            {formatLabel} · {formatName}
                        </p>
                    ) : null}
                    <p className="work-title-card__isbn">
                        {isLoading || !title ? (
                            <TextSkeleton width="8em" />
                        ) : (
                            <>
                                {ean13Label} · {title.ean13}
                            </>
                        )}
                    </p>
                </div>
            </div>
            <div className="work-title-card__footer">
                <span className="work-title-card__open">
                    {openLabel}
                    <span className="work-title-card__chevron" aria-hidden>
                        →
                    </span>
                </span>
            </div>
        </button>
    );
};

export default WorkTitleCard;
